"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllTransactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchTransactions();
    }, []);

    const fetchTransactions = async () => {
        try {
            setIsLoading(true);
            const res = await axios.get(
                "https://logicx.premierlam.com/api/get-pixel-main-transactions",
                { headers: { authorization: localStorage.getItem("accessToken") } }
            );
            setTransactions(res.data.data || []);
        } catch {
            toast.error("Failed to fetch transactions");
        } finally {
            setIsLoading(false);
        }
    };

    /* ================= SEARCH FILTER ================= */
    const filteredTransactions = transactions.filter((t) =>
        [
            t.transactions_type,
            t.transactions_id,
            t.transactions_month,
            t.transactions_year,
            t.transactions_amount,
            t.transactions_merchant_name,
            t.transactions_comments,
            t.added_by,
        ]
            .join(" ")
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const d = new Date(dateString);
        return d.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="min-h-screen bg-gray-50 p-2">
                <div className="max-w-7xl mx-auto">

                    {/* HEADER */}
                    <div className="flex justify-between items-start mb-6">
                        <div>
                            <h1 className="text-2xl font-semibold text-gray-900 mb-1">
                                Transactions
                            </h1>
                            <p className="text-gray-500">All transactions</p>
                        </div>

                        <Link
                            to="/add-transaction"
                            className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
                        >
                            + Add Transaction
                        </Link>
                    </div>

                    {/* TABLE CONTAINER */}
                    <div className="bg-white rounded-lg shadow-sm border p-6">

                        {/* SEARCH BAR */}
                        <input
                            type="text"
                            placeholder="Search transactions..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="mb-4 px-4 py-2 border rounded-lg w-64"
                        />

                        <div className="overflow-x-auto">
                            {isLoading ? (
                                <div className="text-center py-6">Loading...</div>
                            ) : (
                                <table className="w-full text-sm">
                                    <thead>
                                        <tr className="border-b text-gray-600 whitespace-nowrap">
                                            <th className="py-3 px-4 text-left">Transaction ID</th>
                                            <th className="py-3 px-4 text-left">Type</th>
                                            <th className="py-3 px-4 text-left">Date</th>

                                            <th className="py-3 px-4 text-left">Month</th>
                                            <th className="py-3 px-4 text-left">Year</th>
                                            <th className="py-3 px-4 text-left">Amount</th>
                                            <th className="py-3 px-4 text-left">Merchant</th>
                                            <th className="py-3 px-4 text-left">Comments</th>
                                            <th className="py-3 px-4 text-left">Created At</th>
                                            <th className="py-3 px-4 text-left">Added By</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredTransactions.map((t) => (
                                            <tr
                                                key={t.id}
                                                className="border-b hover:bg-gray-50 whitespace-nowrap"
                                            >
                                                <td className="py-3 px-4">{t.transactions_id}</td>
                                                <td className="py-3 px-4">{t.transactions_type}</td>
                                                <td className="py-3 px-4">
                                                    {t.transactions_date}
                                                </td>

                                                <td className="py-3 px-4">{t.transactions_month}</td>
                                                <td className="py-3 px-4">{t.transactions_year}</td>
                                                <td className="py-3 px-4">{t.transactions_amount}</td>
                                                <td className="py-3 px-4">
                                                    {t.transactions_merchant_name}
                                                </td>
                                                <td className="py-3 px-4">
                                                    {t.transactions_comments}
                                                </td>
                                                <td className="py-3 px-4">
                                                    {formatDate(t.created_at)}
                                                </td>
                                                <td className="py-3 px-4">{t.added_by}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default AllTransactions;
